
import { useQuery } from '@tanstack/react-query';
import { getStartupAppliedMeetings } from "../utils/api";
import ModernSidebar from "./admin_sidebar";
import ModernHeader from "./modern-header";
import React, { useEffect, useState } from 'react'
import { Calendar, Clock, Eye, Video } from "lucide-react"
import axios from 'axios';




const StartupMeetings = () => {
      const [sidebarOpen, setSidebarOpen] = useState(true);
      const [isMobile, setIsMobile] = useState(false);
        const toggleSidebar = () => setSidebarOpen((prev) => !prev);
        const [email, setEmail] = useState("");
          const [fullName, setFullName] = useState("");
          const [startupProfile, setStartupProfile] = useState(null);
      const { data: meetings, isLoading, refetch } = useQuery({
         queryKey: ["meetings"],
         queryFn: getStartupAppliedMeetings
       });

       const formatToAmPm = (time) => {
    if (!time) return "";

    const [hours, minutes] = time.split(":");
    const date = new Date();
    date.setHours(hours, minutes);

    return date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };



       
         const fetchStartupProfile = async () => {
           try {
             const startupId = localStorage.getItem("startupId");
             const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/startups/${startupId}`);
             setStartupProfile(response.data);
           } catch (error) {
             console.error("Error fetching startup profile:", error);
           }
         };
       
         useEffect(() => {
           fetchStartupProfile();
         }, []);
     
    
     
       useEffect(() => {
         console.log(meetings)
       }, [meetings])
      // 
  return (
      <>
          <div className="flex h-screen bg-gray-50">
            <ModernSidebar
              isOpen={sidebarOpen}
              toggleSidebar={toggleSidebar}
              isMobile={isMobile}
              fullName={fullName}
              email={email}
            />
    
            <div className={`flex flex-col flex-1 transition-all duration-300 ${isMobile ? "ml-0" : "ml-16 md:ml-20 lg:ml-20"}`}>
              <ModernHeader toggleSidebar={toggleSidebar} isMobile={isMobile} />
    
              <main className="flex-1 overflow-y-auto p-4 sm:p-6">
                
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8">
            <div>
              <h1 className="text-3xl font-bold tracking-tight text-gray-900">Meetings</h1>
              <p className="text-gray-500 mt-1">Manage your scheduled mentoring sessions and upcoming discussions.</p>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-8">
            {/* Main Content: Meeting List */}
            <div className="lg:col-span-2 space-y-4">
              {isLoading ? (<MeetingCardSkeleton />) : meetings?.data?.length === 0 ? (<div className="flex flex-col items-center justify-center py-16 text-center">
                <div className="w-16 h-16 mb-4 rounded-full bg-indigo-50 flex items-center justify-center">
                  <Calendar className="w-8 h-8 text-indigo-500" />
                </div>
                <h3 className="text-lg font-semibold text-gray-900">
                  No applied meetings
                </h3>
                <p className="text-sm text-gray-500 mt-1">
                  You haven’t applied to any mentor meetings yet.
                </p>
              </div>
              ) : meetings?.data?.map((meeting) => (
                <div
                  key={meeting._id}
                  className="
        group relative bg-white border border-gray-100 rounded-2xl
        shadow-sm hover:shadow-xl hover:shadow-indigo-500/10
        transition-all duration-300 p-6 overflow-hidden
      "
                >
                  {/* Hover gradient overlay */}
                  <div
                    className="
          absolute inset-0 bg-gradient-to-r
          from-indigo-500/5 to-purple-500/5
          opacity-0 group-hover:opacity-100
          transition-opacity rounded-2xl pointer-events-none
        "
                  />

                  <div className="relative flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">

                    {/* LEFT CONTENT */}
                    <div className="flex items-start gap-4 min-w-0">
                      <div className="p-3 rounded-2xl bg-indigo-50 text-[#fd3e3d] shrink-0">
                        <Video className="w-6 h-6" />
                      </div>

                      <div className="min-w-0">
                        <div className="flex flex-wrap items-center gap-2 mb-1">
                          <h3 className="font-bold text-lg text-gray-900 break-words">
                            {meeting.title}
                          </h3>

                          {meeting.status === "upcoming" ? (
                            <span className="px-2.5 py-0.5 rounded-full text-xs font-medium bg-emerald-50 text-emerald-700 border border-emerald-100">
                              Upcoming
                            </span>
                          ) : (
                            <span className="px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-600 border border-gray-200">
                              Completed
                            </span>
                          )}
                        </div>

                        <p className="text-gray-500 text-sm font-medium">
                          with {meeting.mentorName}
                        </p>

                        <div className="flex flex-wrap items-center gap-x-4 gap-y-2 mt-3 text-sm text-gray-600">
                          <span className="flex items-center gap-1.5 font-medium">
                            <Calendar className="w-4 h-4 text-[#fd3e3d]" />
                            {new Date(meeting.date).toLocaleDateString("en-US", {
                              month: "short",
                              day: "numeric",
                              year: "numeric",
                            })}
                          </span>

                          <span className="flex items-center gap-1.5 font-medium">
                            <Clock className="w-4 h-4 text-[#fd3e3d]" />
                            {formatToAmPm(meeting.startTime)} - {formatToAmPm(meeting.endTime)}
                          </span>


                          <span
                            className={`font-semibold ${meeting.isPaid ? "text-[#fd3e3d]" : "text-indigo-600"
                              }`}
                          >
                            {meeting.isPaid ? `₹${meeting.amount?.toLocaleString("en-IN")}` : "Free Session"}
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* RIGHT ACTION */}
                    <div className="w-full sm:w-auto">
                      {/* <button
                        // onClick={() => onApplyNowClick(meeting)}
                        // disabled={processing === meeting._id}
                        className="
          w-full sm:w-auto px-6 py-2
          text-sm font-medium text-white
          bg-gray-900 hover:bg-black
          rounded-xl shadow-sm
          transition-transform active:scale-95
          disabled:opacity-70
          flex items-center gap-10
        "
                      >



                      <Eye/>  View

                      </button> */}
                    </div>

                  </div>
                </div>
              ))}
            </div>


          </div>
        </main>
            
            </div >
          </div >
    
         
        </>
  )
}

export default StartupMeetings


const MeetingCardSkeleton = () => {
  return (
    <div className="bg-white border border-gray-100 rounded-2xl shadow-sm p-6 animate-pulse">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div className="flex items-start gap-4 w-full">

          <div className="p-3 rounded-2xl bg-gray-200 w-12 h-12 shrink-0" />


          <div className="flex-1">

            <div className="h-5 bg-gray-200 rounded w-2/3 mb-3" />


            <div className="h-4 bg-gray-200 rounded w-1/3 mb-4" />


            <div className="flex gap-4">
              <div className="h-4 bg-gray-200 rounded w-24" />
              <div className="h-4 bg-gray-200 rounded w-32" />
              <div className="h-4 bg-gray-200 rounded w-20" />
            </div>
          </div>
        </div>

        {/* Button */}
        <div className="h-10 w-28 bg-gray-200 rounded-xl self-end sm:self-center" />
      </div>
    </div>

  );
};
